import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { TransactionResultData, TransactionSummaryData, 
  TransactionResponseData, TransactionErrorData } from '../../DTO/transaction-summary';
import { TransactionService } from '../../../services/transactionservice';
import  { ToastrService } from 'ngx-toastr';

import { CollectionViewer, DataSource, SelectionChange } from '@angular/cdk/collections';
import { FlatTreeControl, NestedTreeControl } from '@angular/cdk/tree';
import {  Injectable } from '@angular/core';
import { MatTreeNestedDataSource } from '@angular/material/tree';
import { BehaviorSubject } from 'rxjs';

//Request tree view
export class FileNode {
  children: FileNode[] | undefined;
  filename: any;
  type: any;
  markedForDelete:boolean=false;
  isRootNode:boolean=false;
  isJsonAvail:boolean=true;
}
let RESPONSE_TREE_DATA="";
let REQUEST_TREE_DATA="";
// Request tree view
@Component({
  selector: 'app-transaction-summary',
  templateUrl: './transaction-summary.component.html',
  styleUrls: ['./transaction-summary.component.css']
})
export class TransactionSummaryComponent implements OnInit {
  MessageID: any;

  //request tree view
  dataChange = new BehaviorSubject<FileNode[]>([]);
  filteredNodes:FileNode[]=[]
  initialNodes:FileNode[]=[]
  get data(): FileNode[] { return this.dataChange.value; }
  nestedTreeControl: NestedTreeControl<FileNode>;
  nestedDataSource: MatTreeNestedDataSource<FileNode>;
  //request tree view
  isRequestJSONAvail:boolean=true;

   //response tree view
   responseDataChange = new BehaviorSubject<FileNode[]>([]);
   responseFilteredNodes:FileNode[]=[]
   responseInitialNodes:FileNode[]=[]
   get responseData(): FileNode[] { return this.responseDataChange.value; }
   responseNestedTreeControl: NestedTreeControl<FileNode>;
   responseNestedDataSource: MatTreeNestedDataSource<FileNode>;
   //response tree view

  panelOpenState = false;
  IsResponseAvailable = false;
  IsCollapsed = true;
  isLoading: boolean = true;
  showDetails:string;
  requestTabTitle:String="";
  input=new TransactionSummaryData();
  public transactionResultData: TransactionResultData = new TransactionResultData();
  public transactionRequestData: TransactionSummaryData = new TransactionSummaryData();
  public transactionResponseData: TransactionResponseData = new TransactionResponseData();
  public transactionErrorData: TransactionErrorData = new TransactionErrorData();

  constructor(private route: ActivatedRoute,private router: Router,
    private transactionService: TransactionService, private toastr:ToastrService) {
      this.route.paramMap.subscribe((params) => {
        this.input.RequestID = params.get('id');
        this.input.Initiator = params.get('initiator');
      });

      //request treeview
      this.nestedTreeControl = new NestedTreeControl<FileNode>(this._getChildren);
      this.nestedDataSource = new MatTreeNestedDataSource();  
      this.dataChange.subscribe(data => this.nestedDataSource.data = data);
      //request treeview

      //response treeview
      this.responseNestedTreeControl = new NestedTreeControl<FileNode>(this._getResponseChildren);
      this.responseNestedDataSource = new MatTreeNestedDataSource();  
      this.responseDataChange.subscribe(data => this.responseNestedDataSource.data = data);
      //response treeview
  }

  ngOnInit(): void {
    this.loadTransactionSummaryHeader();
  }
  //request treeview
  hasNestedChild = (_: number, nodeData: FileNode) => !nodeData.type;
  private _getChildren = (node: FileNode) => node.children;
  //request treeview

   //response treeview
   hasResponseNestedChild = (_: number, nodeData: FileNode) => !nodeData.type;
   private _getResponseChildren = (node: FileNode) => node.children;
   //response treeview
  loadTransactionSummaryHeader(){
    this.transactionService.getTransactionSummaryHeader(this.input).subscribe(res=>{
      try {
        if(res.ResponseStatus==true && res.ResponseData){
          this.transactionRequestData=res.ResponseData;
          this.requestTabTitle=res.ResponseData.MessageType!=''?res.ResponseData.MessageType:'Request';
          //Request treeview
          if(res.ResponseData.RequestJson!=null && res.ResponseData.RequestJson!='')
          {
            if(res.ResponseData.RequestJson=="{}")
              this.isRequestJSONAvail = false;
            // this.requestTabTitle=res.ResponseData.MessageType!=''?res.ResponseData.MessageType:'Request';
            let requestJsonObject=JSON.parse(res.ResponseData.RequestJson)
            REQUEST_TREE_DATA=JSON.stringify(requestJsonObject);
            //Request treeview
            const requestDataObject = JSON.parse(REQUEST_TREE_DATA);
            const data = this.buildRequestFileTree(requestDataObject,true);
            this.dataChange.next(data);
          }
          //Response treeview
          var jsonArray: string[]=[];
          res.ResponseData.ResponseData.forEach(element => {
            if(element.ResponseJson !=null && element.ResponseJson!='')
            {
              let jObject=JSON.parse(element.ResponseJson)
              let responseTitle = "Message Id="+(element.MessageId!=null?element.MessageId:"")+"|"+
              "Relates To Message Id="+(element.RelatesToMessageId!=null?element.RelatesToMessageId:"")+"|"+"Message Type="+element.MessageType+
              "|"+"From="+element.TransactionFrom+"|"+"To="+element.TransactionTo +
              "|"+"Response Status="+element.ResponseStatus+"|"+"Response Date="+element.ResponseDate;
              if(element.ResponseJson == "{}")
                responseTitle = responseTitle + "|"+"IsResponseJsonAvail=false";
              else
                responseTitle = responseTitle + "|"+"IsResponseJsonAvail=true";
              jObject['ResponseTitle']=responseTitle;

              jsonArray.push(jObject)
            }
          });
          if(jsonArray.length>0)
          { 
            this.IsResponseAvailable =true;        
            RESPONSE_TREE_DATA=JSON.stringify(jsonArray);
            const responseDataObject = JSON.parse(RESPONSE_TREE_DATA);
            const data = this.buildResponseFileTree(responseDataObject,false);
            this.responseDataChange.next(data);
          }
          //Response treeview
        }
        else if(res.ResponseStatus==false&& res.ResponseMessage!=''){
          this.toastr.error(res.ResponseMessage);
        }
        this.isLoading=false;
      }
      catch(error:any){
        this.isLoading=false;
        this.toastr.error('Invalid Request/Response data');
      }
    },(error: any)=>{
      this.isLoading=false;
      this.toastr.error(error);
    });
    
  }

  //request treeview
  buildRequestFileTree(obj: any,isExpand:boolean): FileNode[] {
    return Object.keys(obj).reduce<FileNode[]>((accumulator, key) => {
      const value = obj[key];
            const node = new FileNode();
            node.filename = key;
  
        if (value != null) {
          if (typeof value === 'object') {
            node.children = this.buildRequestFileTree(value,isExpand);
          } else {
            if(value==null || value=='')
            {
              node.markedForDelete=true;
            }
            node.type = value;
          }
        }
        if(isExpand)
        {
        this.nestedTreeControl.expand(node);
        }
        else{
          this.nestedTreeControl.collapse(node);
        }
        return accumulator.concat(node);
        
      }, []);
    }

    expandorcollapse(val:string){
    let text=document.getElementById('filternodeId') as HTMLInputElement;
      this.filterNodes(text?.value,val=="expand"?true:false)
      if(val=="expand"){
        this.IsCollapsed = false;
      }
      else{
        this.IsCollapsed = true;
      }
    }

    filterNodes(val:string,isExpand:boolean){
        const data=REQUEST_TREE_DATA;
        const usersJson: any[] = Array.of(REQUEST_TREE_DATA);
        const dataObject = JSON.parse(REQUEST_TREE_DATA);
        this.initialNodes=this.buildRequestFileTree(dataObject,isExpand);
        let filteredtree=this.markNodeForRemoval(this.initialNodes,val,isExpand);
        this.filteredNodes=this.removeNodes(filteredtree);
        this.dataChange.next(this.filteredNodes);
        this.nestedDataSource = new MatTreeNestedDataSource();
        this.dataChange.subscribe(data => this.nestedDataSource.data = data);
  }

  applyFilter(event:any){
      this.filterNodes(event.currentTarget?.value,true)
  }

  markNodeForRemoval(tree: FileNode[],val:string,isExpand:boolean): FileNode[] {
    for (let index = 0; index <tree.length; index++) {
      const node = tree[index];
      if (node.children) {
        if (node.filename.toString().toLocaleLowerCase().includes(val.toLocaleLowerCase()))
        {
          node.markedForDelete=false;
        }
        else{
          node.markedForDelete=true;
        }
        const parentCanBeEliminated = this.markNodeForRemoval(node.children,val,isExpand);
      } else {
        if ((node.type!=undefined && node.type.toString().toLocaleLowerCase().includes(val.toLocaleLowerCase()) || 
        node.filename!=undefined && node.filename.toString().toLocaleLowerCase().includes(val.toLocaleLowerCase()))) {
          node.markedForDelete=false;
      }
      else{
       node.markedForDelete=true;
      }
      if(isExpand)
      {
        this.nestedTreeControl.expand(node);
      }
      else{
        this.nestedTreeControl.collapse(node);
      }
      }
    
    }
    return tree;
}

removeNodes(tree: FileNode[]): FileNode[] {
    for (let index = 0; index <tree.length; index++) {
      const node = tree[index];
      if (node.children) {
      let descendants=this.nestedTreeControl.getDescendants(node);
      if(!node.markedForDelete)
      {
        node.children.forEach(element => {
          element.markedForDelete=false;
        });
      }
      if(descendants.filter(x=>!x.markedForDelete).length>0)
      {
        node.markedForDelete=false
      }
      else{
        node.markedForDelete=true;
      }
      const parentCanBeEliminated = this.removeNodes(node.children)
    }
  }
    return tree;
  }
  //request treeview

  //response treeview
  buildResponseFileTree(obj: any,isExpand:boolean): FileNode[] { 
    return Object.keys(obj).reduce<FileNode[]>((accumulator, key) => {
      const value = obj[key];
            const node = new FileNode();
            node.filename = key;
            if(value !=null && value.hasOwnProperty('ResponseTitle'))
            {
              node.filename = value.ResponseTitle;
              node.isRootNode=true;
              //Get Response JSON Avail
              let responseLength=node.filename.length;
              if(node.filename.substring(responseLength-5,responseLength)=="false")
                node.isJsonAvail = false;
              else
                node.isJsonAvail = true;
            }
            if(key=="ResponseTitle")
            {
              node.markedForDelete=true;
            }
  
        if (value != null) {
          if (typeof value === 'object') {
            node.children = this.buildResponseFileTree(value,isExpand);
          } else {
            if(value==null || value=='')
            {
              node.markedForDelete=true;
            }
            node.type = value;
          }
        }
        if(isExpand)
        {
        this.responseNestedTreeControl.expand(node);
        }
        else{
          this.responseNestedTreeControl.collapse(node);
        }
        return accumulator.concat(node);
        
      }, []);
    }

    expandorcollapseResponse(val:string){
    let text=document.getElementById('responseFilternodeId') as HTMLInputElement;
      this.responseFilterNodes(text?.value,val=="expand"?true:false)
    }

    responseFilterNodes(val:string,isExpand:boolean){
        const dataObject = JSON.parse(RESPONSE_TREE_DATA);
        this.responseInitialNodes=this.buildResponseFileTree(dataObject,isExpand);
        let filteredtree=this.markResponseNodeForRemoval(this.responseInitialNodes,val,isExpand);
        this.responseFilteredNodes=this.removeResponseNodes(filteredtree);
        this.responseDataChange.next(this.responseFilteredNodes);
        this.responseNestedDataSource = new MatTreeNestedDataSource();
        this.responseDataChange.subscribe(data => this.responseNestedDataSource.data = data);
  }

  applyResponseFilter(event:any){
      this.responseFilterNodes(event.currentTarget?.value,true)
  }

  markResponseNodeForRemoval(tree: FileNode[],val:string,isExpand:boolean): FileNode[] {
    for (let index = 0; index <tree.length; index++) {
      const node = tree[index];
      if (node.children) {
        if (node.filename.toString().toLocaleLowerCase().includes(val.toLocaleLowerCase()))
        {
          node.markedForDelete=false;
        }
        else{
          node.markedForDelete=true;
        }
        const parentCanBeEliminated = this.markResponseNodeForRemoval(node.children,val,isExpand);
      } else {
        if ((node.type!=undefined && node.type.toString().toLocaleLowerCase().includes(val.toLocaleLowerCase()) || 
        node.filename!=undefined && node.filename.toString().toLocaleLowerCase().includes(val.toLocaleLowerCase()))) {
          node.markedForDelete=false;
      }
      else{
       node.markedForDelete=true;
      }
      if(isExpand)
      {
        this.responseNestedTreeControl.expand(node);
      }
      else{
        this.responseNestedTreeControl.collapse(node);
      }
      }
    
    }
    return tree;
}

removeResponseNodes(tree: FileNode[]): FileNode[] {
    for (let index = 0; index <tree.length; index++) {
      const node = tree[index];
      if (node.children) {
      let descendants=this.responseNestedTreeControl.getDescendants(node);
      if(!node.markedForDelete)
      {
        node.children.forEach(element => {
          element.markedForDelete=false;
        });
      }
      if(descendants.filter(x=>!x.markedForDelete).length>0)
      {
        node.markedForDelete=false
      }
      else{
        node.markedForDelete=true;
      }
      const parentCanBeEliminated = this.removeResponseNodes(node.children)
    }
  }
    return tree;
  }

  buildResponseTitle(nodeValue:string)
  {
    let titleElements=nodeValue.split("|");
    let tableCell='';
    titleElements.forEach((element,index) => {
      let keyValue=element.split("=");
      let key="<span class=\"response-title-key\">"+keyValue[0]+"</span>";
      let value="";
      if(keyValue[1]!=undefined)
      {
      value="<span class=\"response-title-value\"> "+element.split("=")[1]+"</span>";
      }
      if(index == 0 || index == 1 || index==6)
        tableCell=tableCell.concat("<td class=\"response-title-border response-width-15\">"+value+"</td>");
        else if(index == 2)
        tableCell=tableCell.concat("<td class=\"response-title-border response-width-14\">"+value+"</td>");
      else if(index == 3 || index ==4)
        tableCell=tableCell.concat("<td class=\"response-title-border response-width-8\">"+value+"</td>");
      else if(index == 5)
        tableCell=tableCell.concat("<td class=\"response-title-border response-width-20\">"+value+"</td>");
    });
    return "<table class=\"response-title-width\"><tr>"+tableCell+"</tr></table><br>"
  }
  //request treeview
  public redirectToDetails = (id: string) => {
    window.open('summarytransaction/'+id+'/'+this.input.Initiator);
  }

  showHideDetails()
  {
    if(this.showDetails=="Hide Details")
    {
      this.showDetails="Show Details"
    }
    else{
      this.showDetails="Hide Details"
    }
  }

  expandRequest(){
    if(this.IsCollapsed==true)
      this.IsCollapsed=false;
    else
      this.IsCollapsed=true;
  }
}


